import { useState, useEffect } from "react";
import axios from "axios";
import { useAtom } from "jotai";
import { gbState } from "../../../../components/shared/GlobalState";

const UpcomingBirthdayComponent = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [{ errorLogApi, user }] = useAtom(gbState);

  // Function to get upcoming birthdays
  const getUpcomingBirthdays = (families) => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // Adding 1 since getMonth() returns 0-11

    // Function to check if a month is within range
    const isMonthInRange = (birthMonth) => {
      const month = parseInt(birthMonth);
      for (let i = 0; i <= 3; i++) {
        if (((currentMonth + i - 1) % 12) + 1 === month) {
          return true;
        }
      }
      return false;
    };

    // Get all members with birthdays in the next 3 months
    const upcomingBirthdays = [];

    families.forEach((family) => {
      // Check primary member
      if (isMonthInRange(family.primary_member_id.birth_month)) {
        upcomingBirthdays.push({
          name: `${family.primary_member_id.first_name} ${family.primary_member_id.last_name}`,
          day: family.primary_member_id.birth_day,
          month: family.primary_member_id.birth_month,
          familyName: family.family_name,
        });
      }

      // Check family members
      if (family.family_member) {
        family.family_member.forEach((member) => {
          if (isMonthInRange(member.birth_month)) {
            upcomingBirthdays.push({
              name: `${member.member_id.first_name} ${member.member_id.last_name}`,
              day: member.birth_day,
              month: member.birth_month,
              familyName: family.family_name,
            });
          }
        });
      }
    });

    // Sort by month and day
    return upcomingBirthdays.sort((a, b) => {
      if (parseInt(a.month) === parseInt(b.month)) {
        return parseInt(a.day) - parseInt(b.day);
      }
      return parseInt(a.month) - parseInt(b.month);
    });
  };

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");
      let urlLink = `${process.env.REACT_APP_API_URL}/family/${user.church_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };

      axios(config)
        .then(function (response) {
          const upcomingBirthdays = getUpcomingBirthdays(
            response.data.families
          );
          setData(upcomingBirthdays);
          setIsLoading(false);
        })
        .catch(function (err) {
          console.log("error api call ", err);
          setIsLoading(false);
        });
    };
    getDataFromServer();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const getMonthName = (month) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[parseInt(month) - 1];
  };

  return (
    <div className="p-1">
      {/* <h2 className="mb-4 text-xl font-semibold">Upcoming Birthdays</h2> */}
      <ul className="space-y-2">
        {data.map((birthday, index) => (
          <li key={index} className="p-3 bg-white rounded-lg shadow">
            <div className="flex items-center justify-between">
              <div className="flex-shrink-0 p-3 text-center bg-blue-100 rounded-lg">
                <div className="text-sm font-semibold text-blue-800">
                  {birthday.day}
                </div>
                <div className="text-xs text-blue-600">
                  {getMonthName(birthday.month).substring(0, 3)}
                </div>
              </div>
              <div>
                <span className="font-medium">{birthday.name}</span>
                <span className="ml-2 text-sm text-gray-500">
                  ({birthday.familyName})
                </span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UpcomingBirthdayComponent;
